var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRedesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.61,
    height: 61.61,
    viewBox: "0 0 61.61 61.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_234065",
    "data-name": "Group 234065",
    transform: "translate(-138.895 -203.85)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_653",
    "data-name": "Ellipse 653",
    cx: 30.805,
    cy: 30.805,
    rx: 30.805,
    ry: 30.805,
    transform: "translate(138.895 203.85)",
    fill: "#2d2756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_234064",
    "data-name": "Group 234064",
    transform: "translate(157.177 220.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "phone",
    d: "M26.6,19.805l-1.288,3.951A3.389,3.389,0,0,1,23.5,25.8a16.323,16.323,0,0,1-6.764,1.451A16.53,16.53,0,0,1,5.491,22.83c-.213-.194-.4-.388-.569-.555a16.128,16.128,0,0,1-2.508-3.231,13.725,13.725,0,0,1-.649-1.228A16.923,16.923,0,0,1,0,10.218,17.089,17.089,0,0,1,1.426,3.334a3.377,3.377,0,0,1,2-1.85L7.313.174A3.3,3.3,0,0,1,8.367,0a3.355,3.355,0,0,1,3.176,2.33l1.673,5.109a3.431,3.431,0,0,1-1.678,4.123l-1.218.62a6.772,6.772,0,0,0,1.7,2.861,6.523,6.523,0,0,0,2.789,1.7l.609-1.238a3.337,3.337,0,0,1,2.993-1.883,3.277,3.277,0,0,1,1.059.175l5.019,1.7A3.419,3.419,0,0,1,26.6,19.805Zm-3.176-1.073-5.021-1.7-1.673,3.406a9.86,9.86,0,0,1-7.1-3,10.215,10.215,0,0,1-2.945-7.221l3.346-1.7L8.367,3.406,4.484,4.717a13.694,13.694,0,0,0-1.138,5.5,13.544,13.544,0,0,0,1.422,6.1,10.407,10.407,0,0,0,.5.954,12.813,12.813,0,0,0,1.993,2.572c.15.153.3.306.468.46a13.227,13.227,0,0,0,9,3.542,13.053,13.053,0,0,0,5.4-1.158Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRedesign);
export default __webpack_public_path__ + "static/media/phone-redesign.7a2dea9d0e20f5dd4e4142c239b8741f.svg";
export { ForwardRef as ReactComponent };